module.exports = __webpack_public_path__ + "img/index_list_item_icon_8.0d4b855e.svg";